import {
  SET_PROJECT,
  SET_PROJECT_UNDOABLE,
  SPREAD_DELETED,
  SPREADS_ADDED,
} from './project';
import {
  REORDER_SECTION_SPREADS,
  PAGE_LAST_UPDATE_CHANGED,
  PAGE_THUMB_UPDATED,
  UPDATE_PAGE_THUMB,
  stopThumbs,
} from './pages';
import { Seq, toJS, fromJS } from 'immutable';
import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { generateThumbs } from './pages';
import { setProject } from './project';
import { getImagesMetadata, getProject } from '../utils/zoomServices';
import { renderCanvasFromStore } from './navigation';
import * as Selectors from '../reducers/selectors';
import { clearSelection } from './selection';
import { setLoadedImagesSection } from './loadedImages';
import PicabooConstants from '../common/PicabooConstants';

/**
 *  action constants
 */
export const UPDATE_SECTIONS = 'UPDATE_SECTIONS';
export const SPREAD_UPDATE_PAGE_THUMB = 'SPREAD_UPDATE_PAGE_THUMB';
export const SECTION_UPDATE_PAGE_THUMBS = 'SECTION_UPDATE_PAGE_THUMBS';
export const SECTION_SPREADS_CHANGED = 'SECTION_SPREADS_CHANGED';
export const DELETE_PAGE = 'sections/DELETE_PAGE';
export const MOVE_PAGE = 'sections/MOVE_PAGE';
export const ADD_PAGES = 'sections/ADD_PAGE';
export const ADD_PRINTS = 'sections/ADD_PRINTS';
export const ADD_PAGE_SQUAREPRINT = 'sections/ADD_PAGE_SQUAREPRINT';
export const ADD_PRINT_PAGE = 'sections/ADD_PRINT_PAGE';
const REORDER_SECTIONS = 'REORDER_SECTIONS';
const UPDATE_SECTION_SORTORDER = 'UPDATE_SECTION_SORTORDER';
const UPDATE_SECTIONS_LOCKED = 'UPDATE_SECTIONS_LOCKED';
const ADD_SECTION = 'ADD_SECTION';
const DELETE_SECTION = 'DELETE_SECTION';

export const UPDATED_PORTRAIT_WELL_COUNT =
  'sections/UPDATED_PORTRAIT_WELL_COUNT';
const LOAD_PROJECT_SECTIONS = 'project/LOAD_PROJECT_SECTIONS';
const SET_PROJECT_SECTIONS = 'project/SET_PROJECT_SECTIONS';

function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null
    ? js
    : Array.isArray(js)
      ? Seq(js).map(fromJSOrdered).toList()
      : Seq(js).map(fromJSOrdered).toOrderedMap();
}

/**
 *  reducers
 */
const reducer = function sections(state = fromJSOrdered({}), action) {
  switch (action.type) {
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      let immutable = fromJSOrdered(action.project.sections);
      return action.project.sections != undefined ? immutable : state;

    case UPDATE_SECTIONS:
      return action.sections;
    case PAGE_THUMB_UPDATED:
    case SPREAD_UPDATE_PAGE_THUMB:
    case PAGE_LAST_UPDATE_CHANGED:
      if (action.page) {
        action.sectionId = action.page.sectionId;
        action.pageId = action.page.pageID;
      }
      if (!state.has(action.sectionId)) {
        return state;
      }
      let newState = state.update(action.sectionId, (section) => {
        return section.update('spreads', (spreads) => {
          return spreads.map((spread) =>
            spread.update('pages', (pages) => {
              return pages.map((page) => {
                if (page.get('pageID') === action.pageId) {
                  if (!action.thumbURL) {
                    action.thumbURL = page.get('thumbnailURL');
                  }
                  let updatePage = page.set('thumbnailURL', action.thumbURL);
                  if (action.page && action.page.thumbnailUpdated === true) {
                    updatePage = updatePage
                      .set('dateLastModified', action.page.pageLastUpdated)
                      .set('thumbnailDate', Date.now());
                  }
                  if (action.isBlank !== undefined) {
                    updatePage = updatePage.set(
                      'numBlankPages',
                      action.numBlankPages ?? action.isBlank,
                    );
                  }
                  // if ( action.numBlankPages !== undefined) {
                  //     updatePage = updatePage.set('numBlankPages', action.numBlankPages);
                  // }
                  return updatePage;
                }
                return page;
              });
            }),
          );
        });
      });

      return newState;
    case SECTION_UPDATE_PAGE_THUMBS: {
      if (!state.has(action.sectionID)) {
        return state;
      }
      let newState = state.update(action.sectionID, (section) => {
        return section.update('spreads', (spreads) => {
          return spreads.map((spread) =>
            spread.update('pages', (pages) => {
              return pages.map((page) => {
                return page.set('thumbnailURL', ''); //.set('dateLastModified', Date.now());
              });
            }),
          );
        });
      });
      return newState;
    }
    case SPREAD_DELETED: {
      let spreadID = action.spreadID;

      const newState = state.map((section) => {
        let newSpreads = section.get('spreads').filter((spread) => {
          return spread.get('id') != spreadID;
        });
        return section.set('spreads', newSpreads);
      });
      return newState;
    }
    case SPREADS_ADDED: {
      let sectionToAdd = state.get(action.sectionID);
      let newSpreads = sectionToAdd.get('spreads');
      let insertIndex = action.insertIndex;
      action.spreads.forEach((spread) => {
        newSpreads = newSpreads.insert(insertIndex, fromJS(spread));
        ++insertIndex;
      });
      sectionToAdd = sectionToAdd.set('spreads', newSpreads);
      let newState = state.set(sectionToAdd.get('sectionID'), sectionToAdd);
      return newState;
    }
    case REORDER_SECTION_SPREADS: {
      const section = state.get(action.sectionID);
      const sectionSpreads = section.get('spreads').toJS();
      const newSpreadOrder = action.spreads;

      sectionSpreads.sort(function (a, b) {
        if (newSpreadOrder.indexOf(a.id) < newSpreadOrder.indexOf(b.id)) {
          return -1;
        }
        return 1;
      });

      let newSection = section.set('spreads', fromJSOrdered(sectionSpreads));

      let newState = state.set(action.sectionID, newSection);

      return newState;
    }
    case REORDER_SECTIONS: {
      let newState = state.sort((a, b) => {
        if (a.get('type') == PicabooConstants.SECTION_TYPES.TYPE_INDEX) {
          return 1;
        } else if (b.get('type') == PicabooConstants.SECTION_TYPES.TYPE_INDEX) {
          return -1;
        } else if (
          parseInt(a.get('sortOrder')) < parseInt(b.get('sortOrder'))
        ) {
          return -1;
        }
        return 1;
      });
      return newState;
    }
    case SECTION_SPREADS_CHANGED: {
      const section = state.get(action.sectionID);
      let newSection = section.set('spreads', fromJSOrdered(action.spreads));
      let newState = state.set(action.sectionID, newSection);
      return newState;
    }
    case UPDATE_SECTION_SORTORDER: {
      const section = state.get(action.sectionID);
      if (!section) {
        console.error(
          'Update section sort order failed. Cannot find section id=' +
            action.sectionID,
        );
        return state;
      } else {
        let newSection = section.set('sortOrder', action.sortOrder);
        let newState = state.set(action.sectionID, newSection);
        return newState;
      }
    }
    case DELETE_SECTION: {
      return state.delete(action.sectionID);
    }
    case ADD_SECTION: {
      let newState = state.set(
        action.section.sectionID,
        fromJSOrdered(action.section),
      );
      return newState;
    }
    case UPDATE_SECTIONS_LOCKED: {
      let newState = state;
      action.sections.forEach((s) => {
        newState = newState.set(
          s.sectionID,
          fromJS({
            ...newState.get(s.sectionID).toJS(),
            isLocked: s.isLocked ? 1 : 0,
            lockedBy: s.lockedBy,
          }),
        );
      });
      return newState;
    }
    case ADD_PAGES: {
      const { sectionID } = action;
      return state.updateIn(
        [sectionID, 'spreads'],
        addMorePage.bind(null, action),
      );
    }

    case ADD_PRINTS: {
      const { sectionID } = action;
      return state.updateIn(
        [sectionID, 'spreads'],
        addThePrints.bind(null, action),
      );
    }

    case ADD_PAGE_SQUAREPRINT: {
      return state.updateIn(
        [action.sectionID, 'spreads'],
        addSquarePrintPageSpread.bind(null, action),
      );
    }
    case DELETE_PAGE:
      const { sectionID, spreadIndex, pageIndexes } = action;
      const spread = state.getIn([sectionID, 'spreads', spreadIndex]);
      if (pageIndexes.length === 2 || spread.get('pages').size === 1) {
        return state.deleteIn([sectionID, 'spreads', spreadIndex]);
      }

      const section = state.getIn([sectionID]);
      const spreads = section.get('spreads').toJS();
      let spreadsImmutable = section.get('spreads');

      let affectedPages = [];
      spreads.forEach((pSpread, pSpreadIndex) => {
        pSpread.pages.forEach((pPage, pPageIndex) => {
          if (
            (pSpreadIndex === spreadIndex &&
              pPageIndex !== pageIndexes[0] &&
              pPageIndex !== 0) ||
            pSpreadIndex > spreadIndex
          ) {
            affectedPages.push({
              sourcePageIndex: pPageIndex,
              sourceSpreadIndex: pSpreadIndex,
              targetPageIndex: pPageIndex === 0 ? 1 : 0,
              targetSpreadIndex:
                pPageIndex === 0 ? pSpreadIndex - 1 : pSpreadIndex,
              deleteSpreadIndex:
                spreads[pSpreadIndex].pages[1] === undefined
                  ? pSpreadIndex
                  : null,
            });
          }
        });
      });

      if (affectedPages.length > 0) {
        affectedPages.forEach((affectedPage, affectedPageIndex) => {
          spreadsImmutable = spreadsImmutable.setIn(
            [
              affectedPage.targetSpreadIndex,
              'pages',
              affectedPage.targetPageIndex,
            ],
            fromJS(
              Object.assign(
                {},
                spreads[affectedPage.sourceSpreadIndex].pages[
                  affectedPage.sourcePageIndex
                ],
              ),
            ),
          );
          if (affectedPage.deleteSpreadIndex) {
            spreadsImmutable = spreadsImmutable.delete(
              affectedPage.deleteSpreadIndex,
            );
          }
          if (affectedPageIndex === affectedPages.length - 1) {
            //check to see if we need to remove the next page in the last spread since nothing is replacing it
            let pages = spreadsImmutable.getIn([
              affectedPage.targetSpreadIndex,
              'pages',
            ]);
            if (
              pages.size === 2 &&
              pages.get(0).get('pageID') === pages.get(1).get('pageID')
            ) {
              spreadsImmutable = spreadsImmutable.deleteIn([
                affectedPage.targetSpreadIndex,
                'pages',
                1,
              ]);
            }
          }
        });
      } else {
        spreadsImmutable = spreadsImmutable.deleteIn([
          spreadIndex,
          'pages',
          pageIndexes[0],
        ]);
      }

      spreadsImmutable.forEach((s, i) => {
        if (i >= spreadIndex) {
          spreadsImmutable = spreadsImmutable.setIn(
            [i, 'pageCount'],
            s.get('pages').size.toString(),
          );
        }
      });

      return state.setIn([sectionID, 'spreads'], spreadsImmutable);

    case MOVE_PAGE:
      return handleMovePage(state, action);

    default:
  }

  return state;
};

/**
 *  actions
 */
export function addPrints(sectionID, numberOfPages, spreadID) {
  return {
    type: ADD_PRINTS,
    sectionID,
    numberOfPages,
    spreadID,
  };
}

export function addPages(
  sectionID,
  spreadID,
  pageID,
  isAfter,
  numberOfPages,
  sectionStartsOnRightPage,
  addPagesLayoutType,
) {
  let action = {
    type: ADD_PAGES,
    sectionID,
    spreadID,
    pageID,
    isAfter,
    numberOfPages,
    sectionStartsOnRightPage,
    addPagesLayoutType,
  };

  return action;
}

export function updateSections(sections) {
  return {
    type: UPDATE_SECTIONS,
    sections,
  };
}

export function updateSectionsPageThumb(sectionId, pageId, thumbURL, isBlank) {
  return {
    type: SPREAD_UPDATE_PAGE_THUMB,
    sectionId,
    pageId,
    thumbURL,
    isBlank,
  };
}

export function updateSectionSortOrder(sectionID, sortOrder) {
  return {
    type: UPDATE_SECTION_SORTORDER,
    sectionID,
    sortOrder,
  };
}

export function updateSectionsLocked(sections) {
  return {
    type: UPDATE_SECTIONS_LOCKED,
    sections,
  };
}

export function reorderSections() {
  return {
    type: REORDER_SECTIONS,
  };
}

export function deleteSection(sectionID) {
  return {
    type: DELETE_SECTION,
    sectionID,
  };
}

function handleMovePage(state, action) {
  const { sectionID, fromSpread, fromIndex, toSpread, toIndex } = action;

  const section = state.getIn([sectionID]);
  const spreads = section.get('spreads').toJS();

  const sourcePage = spreads[fromSpread].pages[fromIndex];
  const destPage = spreads[toSpread].pages[toIndex];

  let startSpreadIndex = Math.min(fromSpread, toSpread);
  let endSpreadIndex = Math.max(fromSpread, toSpread);

  let pages = [];
  for (
    let spreadIndex = startSpreadIndex;
    spreadIndex <= endSpreadIndex;
    spreadIndex++
  ) {
    let spread = spreads[spreadIndex];

    for (let pageIndex = 0; pageIndex < spread.pages.length; pageIndex++) {
      let currentPage = spread.pages[pageIndex];
      pages.push(currentPage);
    }
  }

  let isMovingForward =
    fromSpread < toSpread || (fromSpread === toSpread && fromIndex < toIndex);
  let sourcePageIndex = pages.indexOf(sourcePage);
  pages.splice(sourcePageIndex, 1);
  let destPageIndex = pages.indexOf(destPage);
  if (isMovingForward) {
    destPageIndex++;
  }
  pages.splice(destPageIndex, 0, sourcePage);

  // Now just rebuild the spreads
  for (let index = startSpreadIndex; index <= endSpreadIndex; index++) {
    let spread = spreads[index];
    let spreadPageCount = spread.pages.length;
    spread.pages = [];
    for (let pageIndex = 0; pageIndex < spreadPageCount; ++pageIndex) {
      spread.pages.push(pages.shift());
      spread.pages[pageIndex].pageIndex = pageIndex;
    }
  }

  return state.setIn([sectionID, 'spreads'], fromJS(spreads));
}

/**
 * Sagas
 */
function* setProjectSaga(action) {
  let sections = [];
  if (
    action.project != undefined &&
    action.project.project.type !== PicabooConstants.PRODUCT_TYPES.YEARBOOK
  ) {
    sections = action.project.sections;
  } else {
    let section = yield select(Selectors.sectionSelector);
    if (!section) {
      return;
    }
    let retSection = {};
    if (action.sectionID) {
      retSection[action.sectionID] = section.toJS();
    } else {
      retSection[section.get('sectionID')] = section.toJS();
    }
    sections = retSection;
  }

  const thumbs = [];
  for (let sectionId in sections) {
    let section = sections[sectionId];

    if (section) {
      let spreads = section.spreads;
      if (spreads) {
        for (let spreadIndex in spreads) {
          let spread = spreads[spreadIndex];
          for (let pageIndex in spread.pages) {
            let p = spread.pages[pageIndex];
            let thumb = p.thumbnailURL;
            if (thumb == null || thumb == '') {
              thumbs.push({
                pageID: p.pageID,
                spreadID: spread.id,
                sectionID: sectionId,
                isBlank: p.numBlankPages == p.ratioBase,
                pageRatio: p.ratio + p.ratioBase,
              });
            }
          }
        }
      }
    }
  }

  if (thumbs.length > 0) {
    yield put(stopThumbs());
    yield put(generateThumbs(thumbs));
  }
}

function* setupSagas() {
  yield takeEvery(
    [
      SET_PROJECT,
      SET_PROJECT_UNDOABLE,
      SECTION_UPDATE_PAGE_THUMBS,
      SET_PROJECT_SECTIONS,
    ],
    setProjectSaga,
  );
}

const newPage = (pageIndex) => {
  return {
    pageID: 'tempPageID' + Math.random(),
    isNewPage: true,
    isModified: true,
    pageIndex,
  };
};

const newSpread = () => {
  return {
    id: 'tempSpreadID' + Math.random(),
    isNewSpread: true,
    isModified: true,
    pageCount: '2',
    pages: [newPage(0), newPage(1)],
  };
};

const newHalfSpread = (page) => {
  const pageCount =
    typeof page.get === 'function' && page.get('pageType') === 'C' ? '0' : '1';
  return {
    id: 'tempSpreadID' + Math.random(),
    isNewSpread: true,
    isModified: true,
    pageCount,
    pages: [page],
  };
};

function findInsertPoint(spreads, action) {
  //find the page.
  let pageIndex = undefined;
  let spreadIndex = undefined;
  for (let si = 0; si < spreads.size; si++) {
    if (spreads.get(si).get('id') === action.spreadID) {
      spreadIndex = si;
      break;
    }
  }
  if (spreadIndex !== undefined) {
    const spread = spreads.get(spreadIndex);
    const pages = spread.get('pages');
    for (let pi = 0; pi < pages.size; pi++) {
      if (pages.get(pi).get('pageID') === action.pageID) {
        pageIndex = pi;
        break;
      }
    }

    if (pageIndex !== undefined) {
      if (action.isAfter) {
        if (
          pageIndex === 1 ||
          (spreadIndex === 0 && action.sectionStartsOnRightPage) ||
          (spread && isOnePageFullSpread(spread))
        ) {
          pageIndex = 0;
          spreadIndex++;
        } else {
          pageIndex++;
        }
      }
    }
  }

  return { spreadIndex, pageIndex };
}

function isOnePageFullSpread(spread) {
  return spread.get('pageCount') === 2 && spread.get('pages').size === 1;
}

function updatePagesInSpread(spread, newPages) {
  let newSpread = spread.update('pages', (pages) => fromJS(newPages));
  newSpread = newSpread.set('pageCount', newPages.length.toString());
  let bumped = spread.get('pages').get(1);
  return { newSpread, bumped };
}

function addPageToStartOfSpread(spread, page) {
  let newPages = [page, spread.get('pages').get(0)];
  return updatePagesInSpread(spread, newPages);
}

function addSecondPageToSpread(spread, page) {
  let newPages = [spread.get('pages').get(0), page];
  return updatePagesInSpread(spread, newPages);
}

function bumpFirstPage(spread, page) {
  let insideCover = spread.get('pages').get(0);
  let bumped = spread.get('pages').get(1);
  let newPages = [insideCover, page];
  let newSpread = spread.update('pages', (pages) => fromJS(newPages));

  return { newSpread, bumped };
}

function addMorePage(action, spreads) {
  let { spreadIndex, pageIndex } = findInsertPoint(spreads, action);
  let numberOfPagesToAdd = action.numberOfPages;
  const sectionStartOnRightPage = action.sectionStartsOnRightPage;

  let theBump = undefined;

  if (spreadIndex === 0 && sectionStartOnRightPage) {
    let { newSpread, bumped } = bumpFirstPage(
      spreads.get(spreadIndex),
      fromJS(newPage(pageIndex)),
    );
    spreads = spreads.update(spreadIndex, () => newSpread);
    spreadIndex++;
    numberOfPagesToAdd--;
    theBump = bumped;
  }

  if (pageIndex === 1 && !theBump) {
    let { newSpread, bumped } = addSecondPageToSpread(
      spreads.get(spreadIndex),
      fromJS(newPage(pageIndex)),
    );
    spreads = spreads.update(spreadIndex, () => newSpread);
    spreadIndex++;
    numberOfPagesToAdd--;
    theBump = bumped;
  }

  if (theBump) {
    numberOfPagesToAdd++; //need to add bumped page back in
  }

  let numberOfSpreads = Math.floor(numberOfPagesToAdd / 2);
  numberOfPagesToAdd %= 2;
  const newSpreads = [];
  for (let i = 0; i < numberOfSpreads; i++) {
    newSpreads.push(fromJS(newSpread()));
  }

  if (theBump) {
    let s = newSpread();
    s.pages[1] = theBump;
    newSpreads[newSpreads.length - 1] = fromJS(s);
    theBump = undefined;
  }

  spreads = spreads.splice(spreadIndex, 0, ...newSpreads);
  spreadIndex += numberOfSpreads;

  if (numberOfPagesToAdd === 1) {
    theBump = fromJS(newPage(pageIndex));
  }

  while (theBump && spreadIndex < spreads.size) {
    let { newSpread, bumped } = addPageToStartOfSpread(
      spreads.get(spreadIndex),
      theBump,
      0,
    );
    spreads = spreads.update(spreadIndex, () => newSpread);
    spreadIndex++;
    theBump = bumped;
  }

  if (theBump) {
    spreads = spreads.push(fromJS(newHalfSpread(theBump)));
  }

  return spreads;
}

function addSquarePrintPageSpread(action, spreads) {
  spreads = spreads.push(fromJS(newHalfSpread(newPage(0))));
  return spreads;
}

export function addThePrints(action, spreads) {
  let findKey = spreads.findKey((s) => s.get('id') === action.spreadID) + 1;
  for (let i = 0; i < action.numberOfPages; i++) {
    spreads = spreads.insert(findKey, fromJS(newHalfSpread(newPage(0))));
  }

  return spreads;
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
  saga: setupSagas,
};

export function pageThumbWithCacheKiller(p) {
  let thumb = p.get('thumbnailURL');
  if (thumb && thumb.indexOf('data:image') === 0) {
    return thumb;
  }

  let timeStamp;
  if (p.has('dateLastModified')) {
    timeStamp = p.get('dateLastModified');
  }

  if (!timeStamp) {
    timeStamp = p.get('thumbnailDate');
  }

  if (!timeStamp) {
    timeStamp = Date.now();
  }
  thumb =
    thumb === undefined || thumb === null || thumb === ''
      ? (thumb = false)
      : thumb + '?d=' + timeStamp;

  return thumb;
}
